module.exports = __webpack_public_path__ + "static/img/default-class.72b190b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/default-class.jpg
// module id = XVi6
// module chunks = 1